var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccountLanguage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    fill: "none",
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4D4D4D",
    fillRule: "evenodd",
    d: "M5.38 3.859c-.84 0-1.521.68-1.521 1.52v17.43l3.317-3.318c.177-.176.417-.276.667-.276H22.62c.84 0 1.521-.68 1.521-1.52V5.38c0-.84-.68-1.521-1.52-1.521H5.38zm-3.405 1.52c0-1.88 1.524-3.404 3.405-3.404h17.24c1.88 0 3.405 1.524 3.405 3.405v12.315c0 1.88-1.524 3.404-3.405 3.404H8.233l-4.65 4.65c-.27.27-.675.35-1.027.205-.352-.146-.581-.49-.581-.87V5.38z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#4D4D4D",
    d: "M12.56 11.805l1.546-3.087 1.546 3.087H12.56zm6.017 2.952l-1.29-2.58c-.003-.01-.007-.016-.013-.024l-2.587-5.177c-.22-.44-.938-.44-1.16 0l-2.588 5.177-.012.024-1.291 2.58c-.16.32-.032.711.289.87.323.16.713.033.871-.29l1.117-2.235H16.3l1.116 2.236c.116.228.344.358.579.358.099 0 .197-.022.293-.07.32-.16.449-.549.289-.87z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#4D4D4D",
    fillRule: "evenodd",
    d: "M14.948 6.846c-.17-.342-.523-.492-.84-.492zm0 0l2.578 5.16c.009.013.02.032.029.056l1.282 2.564c.232.465.044 1.028-.419 1.261l-.003.002c-.135.066-.276.098-.42.098-.341 0-.673-.188-.84-.518v-.001l-1.036-2.074h-4.026l-1.035 2.072c-.232.47-.8.652-1.263.422-.468-.231-.651-.799-.42-1.261l1.29-2.578v-.002 0l.015-.03-.002.005.26.13-.253-.144-.005.01 2.586-5.172c.172-.341.524-.492.842-.492m-.32.753l-2.591 5.18-.001.004-.008.016-1.292 2.58c-.089.178-.016.393.158.478.182.09.395.017.48-.156l.001-.002 1.197-2.397h4.748l1.196 2.396c.064.127.19.198.318.198.054 0 .108-.011.164-.038.175-.09.245-.303.158-.48l-1.291-2.58-.002-.003-2.597-5.197c-.049-.098-.166-.168-.318-.168s-.27.07-.32.17zm3.248 5.215l-.002-.002.002.002zm-2.93-4.256l2.018 4.03h-4.036l2.018-4.03zm0 1.303l-1.074 2.144h2.148L14.106 9.37z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountLanguage);
export default __webpack_public_path__ + "static/media/account-language.cfcb5a383224bd9dfea8055145f38724.svg";
export { ForwardRef as ReactComponent };